import { DRAWING_STYLE } from '../../styles';
import { DomCircleOverlay } from './DomCircleOverlay';

/**
 * 创建吸附区域环形指示器（DOM 覆盖物，创建即渲染）
 */
export function createSnapRingOverlay(map: any, startPoint: any) {
  const { snapRing } = DRAWING_STYLE;

  const circle = new DomCircleOverlay(startPoint, {
    size: snapRing.size,
    background: snapRing.background,
    borderWidth: snapRing.borderWidth,
    borderColor: snapRing.borderColor,
  });
  const overlay = circle.mount(map);

  return {
    overlay,
    remove: () => {
      circle.remove(map);
    },
  };
}
